import { type FunctionComponent } from 'react';

import BreakoutRoomOptionsView from './BreakoutRoomOptions';
import BreakoutRoomOptionsContainer from './BreakoutRoomOptionsContainer';

const BreakoutRoomOptions: FunctionComponent = () => (
    <BreakoutRoomOptionsContainer.Provider>
        <BreakoutRoomOptionsView />
    </BreakoutRoomOptionsContainer.Provider>
);

export default BreakoutRoomOptions;
